import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";
import * as config from "../../../common/config";

const service = new Service();

export const GetListAll = async (
  pageIndex = 1,
  pageSize = config.Configs.DefaultPageSize,
  sort = "",
  keyword = ""
) => {
  const params = new URLSearchParams();
  params.append("pageIndex", pageIndex);
  params.append("pageSize", pageSize);
  params.append("sort", sort);
  params.append("keyword", keyword);
  try {
    const res = await service.get(ApiUrl.AnalysisSubmapGetListAll, params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const AnalysisSubListLayer = async (id) => {
  const params = new URLSearchParams();
  params.append("analysisId", id);
  try {
    const res = await service.get(
      ApiUrl.AnalysisSubListLayer,params
    );
    return res;
  } catch (err) {
    throw err;
  }
};
export const GetDetail = async (id) => {
  const params = new URLSearchParams();
  params.append("id", id);
  try {
    const res = await service.get(
      ApiUrl.AnalysisSubmapGetDetail.replace("{id}", id)
    );
    return res;
  } catch (err) {
    throw err;
  }
};
export const UpdateAnalysisSubmap = async (body) => {
  try {
    const res = await service.post(ApiUrl.AnalysisSubmapUpdate, body);
    return res;
  } catch (err) {
    throw err;
  }
};

export const DeleteAnalysisSubmap = async (id,analysisId) => {
  try {
    const params = new URLSearchParams();
    params.append("layerId", id);
    params.append("analysisId", analysisId);
    const res = await service.post(
      ApiUrl.AnalysisSubDelete, params
    );
    return res;
  } catch (err) {
    throw err;
  }
};

export const CreateAnalysisSubmap = async (body) => {
  try {
    const res = await service.post(ApiUrl.AnalysisSubCreate, body);
    return res;
  } catch (err) {
    throw err;
  }
}


